.empty-state-container {
    max-width: 354px;
}
